var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"hiq-calendar-archive__list"},_vm._l((_vm.hits),function(article,index){return _c('Article',{key:'hit' + index,ref:"articles",refInFor:true,attrs:{"article":article}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }